import React, { useState, useEffect, lazy, Suspense } from 'react';
import firebase from '../utils/Firebase';
import { Link } from 'react-router-dom';
import { Spin } from 'antd';


import TopHeader from "../components/TopHeader";
import styled from 'styled-components'
import app_logo from "../img/app_logo.svg";

const AdminNav = lazy(() => import("../components/AdminNav"));
const renderAuthCheckLoader = () => <p> </p>;

const PromoCard = styled.div`
box-shadow: 0px 4px 26px rgba(0, 0, 0, 0.24);
border-radius: 10px;
overflow:hidden;
`

const PromoCardSingle = styled.div`
padding:0 0 10px 0;
`
const PromoCardSingleTitle = styled.div`
    font-size:16px;
    padding:10px 0 0 15px;
    font-weight:500;
`
const PromoCardSingleSubTitle = styled.div`
    font-size:14px;
    padding:0 0 0 15px;
    color: #757575;
`




const Home = () => {

   
        const [items, setItems] = useState([]); //useState() hook, sets initial state to an empty array
        const [isLoading, setisLoading] = useState(true);
    
        useEffect(() => {
            firebase
                .firestore() //access firestore
                .collection("vendors") //access "items" collection
                .onSnapshot(snapshot => {
                    //You can "listen" to a document with the onSnapshot() method.
                    const listItems = snapshot.docs.map(doc => ({
                        //map each document into snapshot
                        key: doc.id, //id and data pushed into items array
                        ...doc.data() //spread operator merges data to id.
                    }));
                    setItems(listItems); //items is equal to listItems
                    setisLoading(false);
                });
        }, []);


    // console.log(items);



    return (
        <>
            <TopHeader pageTitle="All Promo & Discounts" app_logo={app_logo} />
            <Suspense fallback={renderAuthCheckLoader()}>
                <AdminNav />
            </Suspense>
          
            <div className="container">
                <div className="row">
                {isLoading ? <Spin style={{marginTop:"100px"}}/>:''}
                    {items
                        ? items.map((item) =>
                        <div key={item.key} className="col-6 col-md-4 col-lg-3 col-sm-6 mt-3">
                                <Link to={`/details/${item.vendor_name}`} className="text-decoration-none">

                                    <PromoCard className="promo_card" >
                                        <PromoCardSingle >
                                            <img src={item.vendor_image} alt="" width="100%" height="100%" />
                                            <PromoCardSingleTitle>{item.vendor_name}</PromoCardSingleTitle>
                                            <PromoCardSingleSubTitle className="d-none">{item.vendor_tagline}</PromoCardSingleSubTitle>
                                        </PromoCardSingle>
                                    </PromoCard>
                                </Link>
                            </div>)
                        
                        :''}
                </div>
            </div>

        </>);
}

export default Home;